import type { SyntheticEvent } from 'react';
import cardPlaceholder from '../assets/placeholders/card-placeholder.svg';
import cardPlaceholderBroken from '../assets/placeholders/card-placeholder-broken.svg';
import squarePlaceholder from '../assets/placeholders/square-placeholder.svg';
import expansionPlaceholder from '../assets/placeholders/expansion-placeholder.svg';

/**
 * 공용 이미지 자리표시(2026-10-29, 감사 card-controltower#435).
 * 화면마다 인라인 SVG·이모지·회색 박스로 따로 만들던 것을 SVG 한 벌로 통일한다.
 * - `cardPlaceholder` — 카드 이미지 미등록(5:7)
 * - `cardPlaceholderBroken` — 카드 이미지 로드 실패(5:7, 접힌 모서리)
 * - `squarePlaceholder` — 판매처·매입 사진(정사각)
 * - `expansionPlaceholder` — 확장팩·팩·상자(정사각)
 * 표시 크기·`object-fit` 은 쓰는 쪽 스타일 그대로 두고 `src` 만 이 값으로 바꾼다.
 */
export { cardPlaceholder, cardPlaceholderBroken, squarePlaceholder, expansionPlaceholder };

/**
 * `<img onError>` 핸들러를 만든다 — 로드에 실패한 이미지를 `fallback` 으로 바꾼다.
 * 이미 그 자리표시면 다시 바꾸지 않아(대체 파일까지 실패해도) 무한 루프에 빠지지 않는다.
 */
export const imageFallback = (fallback: string) => (e: SyntheticEvent<HTMLImageElement>): void => {
  const img = e.currentTarget;
  if (img.getAttribute('src') === fallback) return;
  img.src = fallback;
};

/** 카드 이미지 로드 실패 → 깨짐 자리표시. */
export const fallbackToBroken = imageFallback(cardPlaceholderBroken);

/** 판매처·매입 사진 등 정사각 이미지 로드 실패 → 정사각 자리표시. */
export const fallbackToSquare = imageFallback(squarePlaceholder);
